import ImageCrud from './ImageCrud.class'
import LeaderIdInfoCrud from './LeaderIdInfoCrud.class'
import AddressCrud from './Address.class'
import CompanyCrud from './Company.class'
import Test from './Test.class'
import moment from 'moment'
import axios from 'axios'
import { cloneDeep, get, has, isObject } from 'lodash'
import UserStatus from './User/UserStatus'
import Role from './Role.class'
import SocialNetwork from './User/SocialNetwork'
import parseJsonArray from './functions/parseJsonArray'
import { EducationUser } from './Education.class'
import AccountData from './AccountData.class'
import Employment from './Employment.class'
import Seo from './Seo.class'
import { EventWithUserStatus } from './Event.class'
import Simple from './SimpleName/Simple.class'

const baseURL = '/api/user/'

export default class User {
	constructor (init = {}) {
		this.id = null
		this.expanded = true
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return
		this.birthday = get(init, 'birthday') ? new Date(init.birthday) : null
		this.address = get(init, 'address') ? new AddressCrud(init.address) : new AddressCrud()
		this.certificates = get(init, 'certificates') && Array.isArray(init.certificates) ? init.certificates : []
		this.certificates_tenders = get(init, 'certificates_tenders') && Array.isArray(init.certificates_tenders) ? init.certificates_tenders : []
		this.certificates_vacancies = get(init, 'certificates_vacancies') && Array.isArray(init.certificates_vacancies) ? init.certificates_vacancies : []

		const companies = get(init, 'companies') && Array.isArray(init.companies) ? init.companies : []
		this.companies = companies.map(company => new CompanyCrud(company))

		this.events = get(init, 'events.data') ? init.events.data : []
		this.tests = get(init, 'tests.data') ? init.tests.data : []

		this.created_at = get(init, 'created_at') ? new Date(init.created_at) : null
		this.deleted_at = get(init, 'deleted_at') ? new Date(init.deleted_at) : null
		this.email = get(init, 'email') ? init.email : ''
		this.alternative_email = get(init, 'alternative_email') ? init.alternative_email : ''
		this.email_verified_at = get(init, 'email_verified_at') ? new Date(init.email_verified_at) : null
		this.father_name = get(init, 'father_name') ? init.father_name : ''
		this.first_name = get(init, 'first_name') ? init.first_name : ''
		this.about = get(init, 'about') ? init.about : ''
		this.gender = get(init, 'gender') ? init.gender : 'male'
		this.id = get(init, 'id') ? init.id : 0
		this.last_name = get(init, 'last_name') ? init.last_name : ''
		this.site = get(init, 'site') ? init.site : ''
		this.updated_at = get(init, 'updated_at') && init.updated_at ? new Date(init.updated_at) : null
		this.phones = init.hasOwnProperty('phones') && Array.isArray(init.phones) ? init.phones.map(phone => phone.toString())
			: parseJsonArray(init.phones).map(phone => phone.toString())
		this.roles = get(init, 'roles') && Array.isArray(init.roles) ? init.roles.map(role => new Role(role)) : []
		this.photo = get(init, 'photo') ? new ImageCrud({ ...init.photo, default: '/static/img/default-user-logo.png' }) : new ImageCrud({ default: '/static/img/default-user-logo.png' })
		this.new_photo = null
		this.leader_data = get(init, 'leader_data') ? new LeaderIdInfoCrud(init.leader_data) : new LeaderIdInfoCrud()
		this.address = get(init, 'address') ? new AddressCrud(init.address) : new AddressCrud()
		this.job = get(init, 'employments') ? this.setEmployments(init.employments) : []
		this.events = get(init, 'events') ? init.events : {}
		this.tests = get(init, 'tests') ? init.tests : {}
		this.custom_certificates = get(init, 'custom_certificates') ? init.custom_certificates : {}
		this.companies = get(init, 'companies') ? init.companies : []
		this.balance = get(init, 'balance') ? init.balance : 0
		this.competences = get(init, 'competences') ? init.competences : {}
		this.org_name = get(init, 'org_name') ? init.org_name : ''
		this.org_url = get(init, 'org_url') ? init.org_url : ''
		this.inn = get(init, 'inn') ? init.inn : ''
		this.new_password = ''
		this.check = false
		this.front_url = get(init, 'front_url') ? `${init.front_url}/user/${this.id}` : false
		this.frontUrlDomain = get(init, 'front_url') ? init.front_url : false
		this.errors = {}
		this.soc_networks = get(init, 'soc_networks') ? this.setSocialList(init.soc_networks) : []
		this.education = get(init, 'education') ? this.setEducationList(init.education) : []
		this.account_data = get(init, 'account_data') ? this.setAccountData(init.account_data) : []
		this.hide_account = get(init, 'hide_account') ? init.hide_account : false
		this.account_progress = get(init, 'account_progress') ? init.account_progress : false
		this.seo = get(init, 'seo') ? new Seo(init.seo) : new Seo({
			model_type: 'App\\User',
			model_id: this.id
		})

		this.permissions = get(init, 'permissions', [])
		// this.permissions = get(init, 'permissions') && Array.isArray(init.permissions) ? init.permissions.map(perm => new Permission(perm)) : []

		if (get(init, 'fields')) {
			if (typeof init.fields === 'string') {
				this.fields = JSON.parse(init.fields)
			} else {
				this.fields = init.fields
			}
		} else {
			this.fields = {}
		}

		this.events_for_status = get(init, 'events_for_status') ? this.setEventsForStatus(init.events_for_status) : []
		this.special_agreement = get(init, 'special_agreement', false)
	}

	get description () {
		return get(this.fields, 'description') ? this.fields.description : ''
	}

	set description (val) {
		this.fields.description = val
	}

	copy () {
		const cloneDeep = require('lodash/cloneDeep')
		return new User(cloneDeep(this))
	}

	get formData () {
		const formData = new FormData()

		formData.append('father_name', this.father_name)
		formData.append('balance', this.balance)
		formData.append('first_name', this.first_name)
		formData.append('last_name', this.last_name)
		formData.append('gender', this.gender)
		formData.append('about', this.about)
		formData.append('birthday', moment(this.birthday).format('YYYY-MM-DD'))
		formData.append('org_name', this.org_name)
		formData.append('org_url', this.org_url)
		formData.append('inn', this.inn)
		formData.append('fields', JSON.stringify(this.fields))
		formData.append('region_id', this.address.region.id)
		formData.append('city_id', this.address.city.id)
		formData.append('hide_account', this.hide_account ? 1 : 0)
		if (this.alternative_email) {
			formData.append('alternative_email', this.alternative_email)
		}

		if (this.new_photo) {
			formData.append('photo', this.new_photo)
		}
		if (this.new_password) {
			formData.append('password', this.new_password)
		}
		formData.append('phones', JSON.stringify(this.phones))

		let jobDateError = false
		this.errors = {}
		if (this.job.length) {
			this.job.forEach((jobItem, index) => {
				if (jobItem.dateIsCorrect) {
					if (jobItem.company.id) {
						formData.append(`job[${index}][company_id]`, jobItem.company.id)
					}
					if (jobItem.position) {
						formData.append(`job[${index}][position]`, jobItem.position)
					}
					if (jobItem.description) {
						formData.append(`job[${index}][description]`, jobItem.description)
					}
					if (jobItem.start_year) {
						formData.append(`job[${index}][start_year]`, jobItem.start_year)
					}
					if (jobItem.start_month) {
						formData.append(`job[${index}][start_month]`, jobItem.start_month)
					}
					if (jobItem.end_year) {
						formData.append(`job[${index}][end_year]`, jobItem.end_year)
					}
					if (jobItem.end_month) {
						formData.append(`job[${index}][end_month]`, jobItem.end_month)
					}
				} else {
					console.warn('Невалидная дата начала/конца работы:', jobItem)
					jobDateError = true
					this.errors = {
						...this.errors,
						[`job~${index}~start_month`]: 'Данные о месяце начала работы не корректные',
						[`job~${index}~start_year`]: 'Данные о годе начала работы не корректные',
						[`job~${index}~end_month`]: 'Данные о месяце окончания работы не корректные',
						[`job~${index}~end_year`]: 'Данные о годе окончания работы не корректные'
					}
				}
			})
		}
		if (jobDateError) return null

		if (this.soc_networks.length) {
			this.soc_networks.forEach((socItem, socIndex) => {
				formData.append(`social[${socIndex}][social_leader_id]`, socItem.leader_id)
				formData.append(`social[${socIndex}][social_link]`, socItem.social_link)
			})
		}

		return formData
	}

	get nickname () {
		if (this.first_name && this.last_name) {
			return this.first_name ? this.first_name + ' ' + this.last_name : this.last_name
		}

		return this.email
	}

	get fullName () {
		let full = this.last_name || ''
		full += this.first_name ? ' ' + this.first_name : ''
		full += this.father_name ? ' ' + this.father_name : ''

		return full
	}

	set fullName (name) {
		if (!name) {
			return
		}

		let nameArray = name.split(' ')
		nameArray = nameArray.filter(item => !!item)
		this.last_name = nameArray[0] || ''
		this.first_name = nameArray[1] || ''
		this.father_name = nameArray[2] || ''
	}

	get logo () {
		return this.photo.medium || this.photo.original || this.photo.default
	}

	get defaultPhone () {
		return this.phones.length ? this.phones[0] : ''
	}

	set defaultPhone (phone) {
		this.phones[0] = phone
	}

	get age () {
		const _moment = moment(new Date())
		const _birthday = moment(this.birthday)
		return Math.floor(_moment.diff(_birthday, 'years', true))
	}

	get nameWithEmail () {
		return `${this.id}: ${this.fullName} — ${this.email}`
	}

	get permissionAccess () {
		return this.can(/^show\.admin-page.*$/)
	}

	get permissionAccessAdminOnly () {
		return this.can('admin')
	}

	/**
	 * Просмотреть есть ли одна из ролей у пользователя
	 *
	 * @param {string|RegExp} rolesAndPermissions
	 * @return {boolean}
	 */
	can (...rolesAndPermissions) {
		if (!rolesAndPermissions.length) return true

		return rolesAndPermissions.some((option) => {
			if (option instanceof RegExp) {
				return this.roles.map(v => v.name).some(name => option.test(name)) ||
					this.permissions.map(v => v.name).some(name => option.test(name))
			}

			if (typeof option === 'string') {
				return this.roles.map(v => v.name).includes(option) || this.permissions.map(v => v.name).includes(option)
			}

			throw Error('Не валидные опции')
		})

		// return this.roles.some(role => rolesAndPermissions.includes(role)) || this.permissions.some(perm => rolesAndPermissions.includes(perm))
	}

	get socListCorrect () {
		let correct = true
		SocialNetwork.networkList.forEach(item => {
			const duplicate = this.soc_networks.filter(itemFilter => itemFilter.social_name === item.social_name)
			if (duplicate.length > 1) {
				duplicate.forEach(itemFor => {
					itemFor.hasDuplicate = true
					correct = false
				})
			} else if (duplicate.length === 1) {
				duplicate[0].hasDuplicate = false
			}
		})
		return correct
	}

	static url = baseURL

	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new User(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	/**
	 * get user by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
	/**
	 * update user
	 * @returns {Promise}
	 */
	update () {
		if (!this.formData) {
			console.warn('Сохранение не возможно, formData=null')
			return
		}

		return axios.post(`${baseURL}${this.id}`, this.formData)
			.then(res => {
				this.setDefaultData(res.data.data)
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}
	/**
	 * create event by id
	 * @returns {Promise}
	 */
	async create () {
		return await axios.post(`${baseURL}`, this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	delete () {
		return axios.delete(`${baseURL}${this.id}`)
	}

	restore () {
		return axios.post(`${baseURL}${this.id}/restore`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	getTests (params) {
		if (!this.id) return false

		return axios.get(`${baseURL}${this.id}/test`, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Test(item))
				}
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	detachTests (arr = []) {
		const formData = new FormData()
		arr.forEach(item => {
			formData.append(`test[${item.id}]`, 0)
		})

		return axios.post(`${baseURL}${this.id}/test`, formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	attachTests (arr = []) {
		const formData = new FormData()
		arr.forEach(item => {
			formData.append(`test[${item.id}]`, 1)
		})

		return axios.post(`${baseURL}${this.id}/test`, formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	changeTest (testId, tryCount) {
		const formData = new FormData()
		formData.append(`test[${testId}][try_count]`, tryCount)

		return axios.post(`${baseURL}${this.id}/test/update`, formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	createErrors (obj) {
		let newObj = {}
		for (let key in obj) {
			const newErrorStr = obj[key].reduce((accumulator, item) => {
				return accumulator + item
			}, '')
			const newKey = key.replaceAll('.', '~')
			newObj[newKey] = newErrorStr
		}
		this.errors = newObj
	}

	static userGenderList = [
		{
			id: 'male',
			name: 'Мужской',
			value: 'male'
		}, {
			id: 'female',
			name: 'Женский',
			value: 'female'
		}
	]
	setSocialList (arr) {
		if (Array.isArray(arr) && arr.length) {
			return arr.map(item => new SocialNetwork({
				user_id: this.id,
				...item
			}))
		} else {
			return []
		}
	}
	setEducationList (arr) {
		if (Array.isArray(arr) && arr.length) {
			return arr.map(item => new EducationUser(item))
		} else {
			return []
		}
	}
	setAccountData (arr) {
		if (Array.isArray(arr) && arr.length) {
			return arr.map(item => new AccountData(item))
		} else {
			return []
		}
	}
	setEmployments (arr) {
		if (Array.isArray(arr) && arr.length) {
			return arr.map(item => new Employment(item))
		} else {
			return []
		}
	}
	detachJobs (arr) {
		if (!arr.length) return

		const formData = new FormData()
		arr.forEach((item, i) => {
			if (get(item, 'company.id')) {
				formData.append(`job[${i}][detach]`, item.company.id)
			}
		})

		return axios.post(`${baseURL}${this.id}`, formData)
	}
	accountDataByType (str) {
		return this.account_data.filter(item => {
			return item.data_type === str
		})
	}
	changeStatusAccountData (item, status) {
		const formData = new FormData()
		formData.append(`data[${item.id}]`, status)

		return axios.post(`${baseURL}${this.id}/account/data`, formData)
	}

	attachEducations () {
		const arr = this.education
		if (!arr.length) return

		const formData = new FormData()
		arr.forEach((item, i) => {
			const university = get(item, 'university.id') ? item.university.id : item.university.university
			formData.append(`education[${i}][university]`, university)
			if (item.faculty) {
				formData.append(`education[${i}][faculty]`, item.faculty)
			}
			if (item.cathedra) {
				formData.append(`education[${i}][cathedra]`, item.cathedra)
			}
			if (item.form) {
				formData.append(`education[${i}][form]`, item.form)
			}
			if (item.specialization) {
				formData.append(`education[${i}][specialization]`, item.specialization)
			}
			if (item.releaseYear) {
				formData.append(`education[${i}][releaseYear]`, item.releaseYear)
			}
		})

		return axios.post(`${baseURL}${this.id}/education`, formData)
			.catch(err => {
				console.error(err)
				return err.response
			})
	}
	detachEducations (arr) {
		if (!arr.length) return

		const formData = new FormData()
		arr.forEach((item, i) => {
			formData.append(`education[${i}][detach]`, item.id)
		})

		return axios.post(`${baseURL}${this.id}/education`, formData)
	}

	static getAllNotify (params) {
		return axios.get(`${baseURL}notify/index`, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new User(item))
				}
			})
	}

	setEventsForStatus (arr) {
		if (Array.isArray(arr) && arr.length) {
			return arr.map(item => new EventForStatus(item)).filter(item => item.event_id.length)
		} else {
			return []
		}
	}

	getEventsParticipant (params) {
		if (!this.id) return null

		return axios.get(`${baseURL}${this.id}/events`, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(a => new EventWithUserStatus(a))
				}
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}
}

export class UserWithStatusEvent extends User {
	constructor (init = {}) {
		super(init)
		this.eventId = get(init, 'eventId') ? init.eventId : null
		this.status = get(init, 'status.status') ? new UserStatus(init.status) : new UserStatus()
		this.formResult = get(init, 'form_result', false)
		this.newFormResult = this.formResult
		this.formAnswers = get(init, 'form_answers') ? this.setFormAnswers(init.form_answers) : []
		this.answersEditable = cloneDeep(this.formAnswers)
		this.certificateAt = get(init, 'certificate_at', false)
		this.certificateNumber = get(init, 'certificate_number', '')
		this.certificateSeries = get(init, 'certificate_series', '')
		this.certificateUrl = get(init, 'certificate_url', null)
		this.hash = get(init, 'hash') ? init.hash : ''
		this.eventUserId = get(init, 'event_user_id') ? init.event_user_id : null
		this.purchased = get(init, 'purchased', false)

		const gameResult = get(init, 'game_result.dataset')
		if (gameResult) {
			gameResult.forEach(item => {
				this[`game_${item.key}`] = item.value
				this[`game_${item.key}_percent`] = item.percent_value
			})
		}
		this.formAnswers.forEach(item => {
			if (item.type === 'separator') return
			this[`answers_${item.name}`] = item
		})
	}
	get hasCertificate () {
		return this.status.status === 4
	}
	setFormAnswers (arr) {
		if (arr && Array.isArray(arr)) {
			return arr.map(a => new UserAnswer(a))
		} else {
			return []
		}
	}
	getInviteLink (frontUrl) {
		if (!this.certificateAt && this.hash && frontUrl) {
			return `${frontUrl}?hash=${this.hash}`
		} else {
			return ''
		}
	}
	updateFormAnswers () {
		const urlData = new URLSearchParams()
		const json = JSON.stringify(this.answersEditable)
		urlData.append(`user[${this.id}][form_answers]`, json)
		return axios.put(`/api/event/${this.eventId}/users`, urlData)
	}
}

class UserAnswer {
	constructor (init) {
		this.type = get(init, 'type', '')
		this.label = get(init, 'label', '')
		this.name = get(init, 'name', '')
		this.required = get(init, 'required', false)
		this.correct = get(init, 'correct', this.type === 'checkbox' ? [] : '')
		this.answer = get(init, 'answer', this.type === 'checkbox' ? [] : '')

		this.answers = []
		if (get(init, 'answers') && Array.isArray(init.answers)) {
			this.answers = init.answers
		}
	}
	isCheckedCheckbox (val) {
		if (!Array.isArray(this.answer)) return
		return this.answer.includes(val)
	}
	setCheckbox (val) {
		const index = this.answer.indexOf(val)
		if (index >= 0) {
			this.answer.splice(index, 1)
			console.log(this.answer)
		} else {
			this.answer.push(val)
		}
	}
}

export class UserWithStatusVacancy extends User {
	/**
	 * @property {boolean} approved - deprecated: use property 'state' instead
	 */
	constructor (init = {}) {
		super(init.user)
		this.approved = get(init, 'approved', false)
		this.formResult = get(init, 'form_result', false)
		this.certificateAt = get(init, 'certificate_at', false)
		this.hash = get(init, 'hash', '')
		this.comment = get(init, 'comment', '')
		this.formAnswers = get(init, 'form_answers') && Array.isArray(init.form_answers) ? init.form_answers : []
		this.state = get(init, 'state') ? new Simple(init.state) : new Simple()

		this.formAnswers.forEach(item => {
			this[`answers_${item.name}`] = item.answer
		})
	}
}

export class UserWithStatusTest extends User {
	constructor (init = {}) {
		super(init)

		this.try_count = get(init, 'try_count') ? init.try_count : 0
		this.passed = get(init, 'passed') ? init.passed : 0
		this.was_passed = get(init, 'was_passed') ? init.was_passed : false
		this.check = false
		this.result = has(init, 'result') ? this.createResultObject(init.result) : [] // deprecated
		this.attempts = has(init, 'attempts') ? new Attempts(init.attempts) : {} // new result field
	}

	createResultObject (str) {
		if (typeof str === 'string') {
			if (!str) return []
			try {
				const json = JSON.parse(str)
				return json
			} catch (e) {
				console.error(e)
				return []
			}
		} else if (Array.isArray(str)) {
			return str
		} else {
			return []
		}
	}
}

export class Attempts {
	constructor (init = {}) {
		this.setData(init)
	}

	setData (obj) {
		if (isObject(obj) && !Array.isArray(obj)) {
			Object.entries(obj).forEach(([k, v]) => {
				this[k] = Array.isArray(v) ? v.map(el => new AttemptsAnswer(el)) : []
			})
		}
	}
}

class AttemptsAnswer {
	constructor (init = {}) {
		this.answer = get(init, 'answer') ? init.answer : ''
		this.question = get(init, 'question') ? init.question : ''
	}
}

export class EventForStatus {
	constructor (init = {}) {
		this.event_id = Array.isArray(get(init, 'event_id')) ? init.event_id.filter(el => Number.isInteger(el)) : []
		this.status = get(init, 'status') ? init.status : 0
	}
}

/**
 * format log for user answer
 * @param {LogClass} obj
 * @returns {object}
 */
export function answerLogItemFormat (obj) {
	const cloneObj = cloneDeep(obj)

	const formAnswerOld = get(obj, 'properties.old.form_answers')
	const formAnswerNew = get(obj, 'properties.attributes.form_answers')
	if (formAnswerOld) {
		cloneObj.properties.old.form_answers = JSON.parse(formAnswerOld)
	}
	if (formAnswerNew) {
		cloneObj.properties.attributes.form_answers = JSON.parse(formAnswerNew)
	}
	return {
		...obj,
		...cloneObj
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/User.class.js